import React from "react";

const Stat_Hyp_Testing = () => {
  return (
    <div>
      <h1>Stat Hyp. Testing</h1>
    </div>
  );
};

export default Stat_Hyp_Testing;
